<script lang="ts" setup>
withDefaults(
  defineProps<{
    isActive?: boolean
    title: string
    link: string
  }>(),
  { isActive: false }
)
</script>

<template>
  <NuxtLink
    class="px-2 py-0.5 text-sm leading-7 text-main-aluminum !no-underline transition hover:text-main-green"
    :class="{ 'rounded-[6px] bg-main-green/5 text-main-green': isActive }"
    :to="link"
  >
    {{ title }}
  </NuxtLink>
</template>
